export const isSuperUser = (roles: UserRoles) => roles.includes("pdtadmin");

export const isAdmin = (roles: UserRoles) =>
	roles.includes("pdt-retail-app-admin");
